/* eslint-disable */
const USER_REPORT = {
  USER_REPORT_DRIVER: 'user/report/driver',
  USER_REPORT_OPERATOR: 'user/report/operator',
  USER_REPORT_ASPUSER: 'user/report/aspUser'
}
export default USER_REPORT
